import { AfterViewInit, Directive, ElementRef, inject } from '@angular/core';

@Directive({
    selector: '[autofocus]',
    standalone: false
})
export class AutofocusDirective implements AfterViewInit {
    private readonly element = inject(ElementRef);

    public ngAfterViewInit(): void {
        this.element.nativeElement.focus();
    }
}
